import makeStyles from '@mui/styles/makeStyles';

const getTextProperties = (fontSize: string) => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize,
  color: "#465869",
});

const styles = (isOnViewMode: boolean) =>
  makeStyles(() => ({
    materialSection: {
      fontFamily: "Manrope !important",

      display: "grid !important",
      gridTemplateColumns: "1fr 1fr 1fr",
      gap: "20px",
      "@media (min-width: 1800px)": {
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
      },
      "@media (min-width: 1310px)": {
        gridTemplateColumns: isOnViewMode ? "1fr 1fr" : "",
      },
      "@media (max-width: 1310px)": {
        gridTemplateColumns: isOnViewMode ? "1fr" : "1fr 1fr",
      },
      "@media (max-width: 767px)": {
        gridTemplateColumns: "1fr",
      },
    },

    subTitle: {
      ...getTextProperties("18px"),
      margin: "32px 0px 24px 0px",
    },

    empty: {
      ...getTextProperties("16px"),
      fontWeight: 500,
    },

    materialBox: {
      border: "1px solid #E4E7EC",
      borderRadius: "8px",
      minHeight: "321px",
    },

    materialTitle: {
      ...getTextProperties("16px"),
      color: "#308CDB",
      marginBottom: "2px",
    },
    materialSubTitle: {
      ...getTextProperties("14px"),
      color: "#98A2B3",
      flexWrap: "nowrap",
    },
    materialProperty: {
      ...getTextProperties("14px"),
      color: "#475467",
    },
    materialValue: {
      ...getTextProperties("14px"),
      color: "#667085",
    },

    boxHeader: {
      marginBottom: "14px",
      padding: "12px 0px 0px 12px",
    },

    boxColumnsTitle: {
      backgroundColor: "#F9FAFB",
      boxShadow: "0px 2px 6px rgba(249, 250, 251, 0.12)",
      height: "32px",
      alignItems: "center",
    },

    boxColumnTitle: {
      ...getColumnTitleByColor("#667085"),
    },

    boxContent: {
      height: "208px",
      display: "block",
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "4px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#93A9BD",
        borderRadius: "2px",
      },
    },

    boxLineRow: {},

    boxLineColumn: {
      paddingLeft: "16px",
      height: "44px",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "16px",
      color: "#667085",
      display: "flex",
    },

    boxFooter: {
      boxShadow: "0px -2px 6px rgba(70, 88, 105, 0.12)",
      height: "42px",
      alignItems: "center",
    },
    boxFooterColumnTitle: {
      ...getColumnTitleByColor("#465869"),
    },

    width60: {
      width: "50%",
    },
    width20: {
      width: "25%",
    },
  }));

export default styles;

const getColumnTitleByColor = (color: string) => ({
  color,
  fontWeight: 700,
  fontSize: "15px",
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: "12px",
});
